import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'

import Button from '../shared/Button'

export const LogoutButton = () => {
  const { logout } = useAuth0()

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })
  }

  return (
    <Button className="button__logout" clickHandler={handleLogout} label={'Log Out'} />
  )
}
